export default "__VITE_ASSET__CqU5rn01__"